import { Directive, ElementRef, Input, HostListener, Renderer2, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
    selector: '[tooltip]',
    standalone: true
})
export class TooltipDirective {
    @Input('tooltip') tooltip: string = '';
    tooltipElement: HTMLElement | null = null;
    offset = 30;

    constructor(private el: ElementRef, private renderer: Renderer2, private sanitizer: DomSanitizer) {
    }

    @HostListener('mouseenter') onMouseEnter() {
        if (!this.tooltipElement) { this.show(); }
    }

    @HostListener('mouseleave') onMouseLeave() {
        if (this.tooltipElement) { this.hide(); }
    }

    private show() {
        this.tooltipElement = this.renderer.createElement('span');
        if (this.tooltipElement) {
            this.tooltipElement.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, this.tooltip) as string;
            this.renderer.appendChild(this.el.nativeElement, this.tooltipElement);

            this.tooltipElement.className = 'tooltip absolute w-[325px] bg-white text-gray-950 text-sm rounded-lg p-4 transition-opacity duration-300 opacity-0 font-[Averta] shadow-[0_4px_18px_0_rgba(0,0,0,0.17)]';

            const top = - this.offset;
            const right = this.offset;

            this.renderer.setStyle(this.tooltipElement, 'top', `${top}px`);
            this.renderer.setStyle(this.tooltipElement, 'right', `${right}px`);
            this.renderer.setStyle(this.tooltipElement, 'opacity', '1');
        }
    }

    private hide() {
        this.renderer.setStyle(this.tooltipElement, 'opacity', '0');
        setTimeout(() => {
            if (this.tooltipElement) {
                this.renderer.removeChild(this.el.nativeElement, this.tooltipElement);
                this.tooltipElement = null;
            }
        }, 300); // Match the transition duration
    }
}
